import myLogo from '../assets/img/logo2.png';
import Box from '@mui/material/Box';
import { Typography, Modal
} from '@mui/material';
//import socketIO from 'socket.io-client';
import {useLoginHook} from '../hook/LoginHook'
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import myLogoOnly from '../assets/img/ProjectManagement2.jpg'
const Login = () => {
  const {msg,Auth,email,setEmail,password,setPassword,confirmRolesOpen,setConfirmRolesOpen,roleList,handleSetRoles, setOtp, otp,otp_ex,loginButton,msgOtp,sendOTp} = useLoginHook()
  const sectionStyle = {
    width: "100%",
   // height: "400px",
    backgroundImage: `url(${myLogoOnly})`, // Use template literal
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };
  return (
     <section className="hero has-background-grey-light is-fullheight is-fullwidth" style={sectionStyle}>
      <div className="hero-body">
        <div className="container drop-shadow-xl/50 opacity-95">
          <div className="columns is-centered">
            <div className="column is-4-desktop">
              {msg && <div className="box_status_error">{msg}</div>}
              <form onSubmit={Auth} className="box">
                <div className='tulisan_login'>
                  <img src={myLogo} alt='' width='89%'/>
                </div>
                <div className='field mt-5'>
                  <label className='label'>Email or Username</label>
                  <div className='controls'>
                    <input
                      type="text"
                      className="input"
                      placeholder="Email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field mt-5'>
                  <label className='label'>Password</label>
                  <div className='controls'>
                    <input
                      type="password"
                      className="input"
                      placeholder="Password"
                      value={password}
                      required
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>
                <br />
                <div className='field mt-5'>
                  <Box sx={{  position: 'relative' }}>  
                    <button className='custom-button' disabled={loginButton}>{loginButton==true ?   "Please wait..." : "Login"}</button><br /><br />
                    {loginButton && (
                      <CircularProgress
                        size={24}
                        sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-20px',
                        marginLeft: '-12px',
                    }}
                  />
                  )}
                  </Box>
                </div>
              </form>
             
            </div>
          </div>
        </div>
      </div>
      
      <Modal
              open={confirmRolesOpen}
              onClose={async () => {
                try{
                 // await logout();
                  setConfirmRolesOpen(false)
                }catch(err){
                  alert(err.message)
                }
                
              }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box className='modals-delegasi' >
                {/* {msgOtp && (
                  <>
                   <span style={{color:"red"}}>{msgOtp}</span><br></br><br></br>
                  </>
                )} */}
                
                {/* <span style={{color:"red"}}><i>* otp number already sent to your email</i></span><br></br><br></br>
                <span><b>OTP NUMBER :</b></span> <input id="otpcoded" name="otpcode" maxLength={5} type="number" max={99999} min={10000} className='form-control' value={otp} onChange={(e) => setOtp(e.target.value)} required></input><span>time left : {otp_ex == 0 ? <a href="#" onClick={sendOTp}>send otp number again</a>  : otp_ex}</span> */}
                <Typography id="modal-modal-title" >
                  <h3>LOGIN AS :</h3><hr style={{borderColor:"gray"}}></hr>
                </Typography>
                <Typography id="modal-modal-description">
                  <Box>
                    {roleList.map((item) => (
                      <div className='mb-5'><button className='btn btn-primary' style={{width:"100%", height:30,fontSize:15}} onClick={()=> handleSetRoles(item.kode)}>{item.kode} - {item.name}</button></div>
                        
                    ))}
                   
                  </Box>
                
                </Typography>
              </Box>
            </Modal>
    </section>
  );
};

export default Login;
